"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var guildCloakColors = ["#D9DBE1", "#413F51", "#DDCB55", "#E98D47", "#B10707", "#6D1313", "#873185", "#4773B3", "#21217D", "#2BBBBB", "#256D6D", "#2F872D"];
var _default = guildCloakColors;
exports.default = _default;